const COPY = {
  marketResearchSolutions: {
    id: 'mrx.MRXNav.marketResearchSolutions',
    defaultMessage: 'Market Research Solutions logo',
    description: '[Type: Header][Vis: med] - Navigation menu logo label'
  },
  homeLink: {
    id: 'mrx.MRXNav.homeLink',
    defaultMessage: 'Link to market research home page',
    description: '[Type: Link][Vis: med] - Link to market research home page'
  },
  solutions: {
    id: 'mrx.MRXNav.solutions',
    defaultMessage: 'Solutions',
    description:
      '[Type: Button][Vis: med] - Labels the sub-menu for market research product links'
  },
  globalSurveyPanel: {
    id: 'mrx.MRXNav.globalSurveyPanel',
    defaultMessage: 'Global survey panel',
    description:
      '[Type: Link][Vis: med] - Labels the link to the Audience market research product page'
  },
  expertSolutions: {
    id: 'mrx.MRXNav.expertSolutions',
    defaultMessage: 'Expert Solutions',
    description:
      '[Type: Link][Vis: med] - Labels the link to the solutions market research product page'
  },
  services: {
    id: 'mrx.MRXNav.services',
    defaultMessage: 'Services',
    description:
      '[Type: Link][Vis: med] - Labels the link to the market research services page'
  },
  moreResources: {
    id: 'mrx.MRXNav.moreResources',
    defaultMessage: 'More Resources',
    description:
      '[Type: Button][Vis: med] - Labels the sub-menu for market research product links'
  },
  audienceTargeting: {
    id: 'mrx.MRXNav.audienceTargeting',
    defaultMessage: 'Audience targeting',
    description:
      '[Type: Link][Vis: med] - Labels the link to the Audience targeting market research help page'
  },
  dataQuality: {
    id: 'mrx.MRXNav.dataQuality',
    defaultMessage: 'Data quality',
    description:
      '[Type: Link][Vis: med] - Labels the link to the data quality market research help page'
  },
  budgetingOptions: {
    id: 'mrx.MRXNav.budgetingOptions',
    defaultMessage: 'Budgeting options',
    description:
      '[Type: Link][Vis: med] - Labels the link to the market research credits page'
  },
  guidesAndCaseStudies: {
    id: 'mrx.MRXNav.guidesAndCaseStudies',
    defaultMessage: 'Guides & case studies',
    description:
      '[Type: Link][Vis: med] - Labels the link to the market research help page'
  },
  getADemo: {
    id: 'mrx.MRXNav.getADemo',
    defaultMessage: 'Get a demo',
    description:
      '[Type: Button][Vis: med] - Labels the link to the market research demo page'
  }
};

export default COPY;
